import { render, staticRenderFns } from "./RemoteWaiting.vue?vue&type=template&id=8ace59ec&"
import script from "./RemoteWaiting.vue?vue&type=script&lang=ts&"
export * from "./RemoteWaiting.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteWaiting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports